(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion-metafileds"] && !Shopify.designMode) return;
  try {
    // Accordion Functionality
  document.addEventListener('DOMContentLoaded', function () {
    function toggleAccordion(button) {
      const content = button.nextElementSibling;
      const icon = button.querySelector('.accordion-icon');

      // Close all other accordions
      document.querySelectorAll('.accordion-content').forEach((item) => {
        if (item !== content) {
          item.classList.remove('active');
          item.previousElementSibling.classList.remove('active');
          item.previousElementSibling.querySelector('.accordion-icon').style.transform = 'rotate(0deg)';
        }
      });

      // Toggle current accordion
      content.classList.toggle('active');
      button.classList.toggle('active');

      if (content.classList.contains('active')) {
        icon.style.transform = 'rotate(180deg)';
      } else {
        icon.style.transform = 'rotate(0deg)';
      }
    }

    // Attach event listeners to all accordion headers
    document.querySelectorAll('.accordion-header').forEach((header) => {
      header.addEventListener('click', function () {
        toggleAccordion(this);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
